import { forwardRef, InputHTMLAttributes, ReactNode } from 'react';
import classNames from 'classnames';
import { generateHtmlId } from '@amf/shared/utils/id';

interface CheckboxFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'value'> {
  label: ReactNode;
  dark?: boolean;
  value?: string | ReadonlyArray<string> | number | boolean;
}

// eslint-disable-next-line react/display-name
const CheckboxField = forwardRef<HTMLInputElement, CheckboxFieldProps>(
  ({ dark, label, className, type, value, ...props }, ref) => {
    const id = generateHtmlId();
    return (
      <div
        className={classNames(
          'FormField',
          {
            'FormField--check': type === 'checkbox',
            'FormField--radio': type === 'radio',
            'FormField--dark': dark,
          },
          className,
        )}
      >
        <input
          type={type}
          {...props}
          id={id}
          ref={ref}
          value={value === true ? '1' : '0'}
          className='FormField__check'
        />
        <label htmlFor={id} className='FormField__checkLabel'>
          {label}
        </label>
      </div>
    );
  },
);

export default CheckboxField;
